export class CityDropdownController {
  constructor(controller) {
    this.controller = controller;
  }

  // ========================================
  // 市区町村ドロップダウン
  // ========================================

  toggleCityDropdown(event) {
    event.stopPropagation();

    // 都道府県が選択されていない場合は何もしない
    if (!this.controller.selectedPrefecture) {
      alert('先に都道府県を選択してください');
      return;
    }

    this.controller.prefectureDropdownController.closePrefectureDropdown();

    const dropdown = this.controller.cityDropdownTarget;

    if (dropdown) {
      if (dropdown.style.display === 'none' || dropdown.style.display === '') {
        dropdown.style.display = 'block';
      } else {
        dropdown.style.display = 'none';
      }
    }
  }

  closeCityDropdown() {
    if (this.controller.hasCityDropdownTarget) {
      this.controller.cityDropdownTarget.style.display = 'none';
    }
  }

  // ========================================
  // 市区町村データ取得
  // ========================================

  async loadCities(prefectureName) {
    if (!prefectureName) {
      return;
    }

    try {
      // 全市区町村を取得（補助金は全国で使えるのでenable_citiesは不要）
      const response = await fetch(`/api/prefecture/${encodeURIComponent(prefectureName)}/cities`);

      if (!response.ok) {
        console.error('市区町村の取得に失敗しました');
        this.showErrorMessage('市区町村の取得に失敗しました。もう一度お試しください。');
        return;
      }

      const cities = await response.json();

      // 全市区町村を有効として保存
      this.controller.cities = cities.map(city => ({
        ...city,
        enabled: true
      }));

      // 市区町村ボタンを生成
      this.renderCityButtons();
    } catch (error) {
      console.error('市区町村の取得中にエラーが発生しました:', error);
      this.showErrorMessage('市区町村の取得中にエラーが発生しました。もう一度お試しください。');
    }
  }

  showErrorMessage(message) {
    this.controller.cityButtonsContainerTarget.textContent = '';
    const errorDiv = document.createElement('div');
    errorDiv.className = 'area-search__dropdown-error';
    errorDiv.textContent = message;
    this.controller.cityButtonsContainerTarget.appendChild(errorDiv);
  }

  // ========================================
  // 市区町村リスト表示
  // ========================================

  renderCityButtons() {
    const container = this.controller.cityButtonsContainerTarget;
    container.textContent = '';
    this.renderCityButtonsInContainer(container);
  }

  renderCityButtonsInContainer(container) {
    // 五十音順のグループ定義
    const kanaGroups = [
      { group: 'あ', kanas: ['ア', 'イ', 'ウ', 'エ', 'オ'] },
      { group: 'か', kanas: ['カ', 'キ', 'ク', 'ケ', 'コ', 'ガ', 'ギ', 'グ', 'ゲ', 'ゴ'] },
      { group: 'さ', kanas: ['サ', 'シ', 'ス', 'セ', 'ソ', 'ザ', 'ジ', 'ズ', 'ゼ', 'ゾ'] },
      { group: 'た', kanas: ['タ', 'チ', 'ツ', 'テ', 'ト', 'ダ', 'ヂ', 'ヅ', 'デ', 'ド'] },
      { group: 'な', kanas: ['ナ', 'ニ', 'ヌ', 'ネ', 'ノ'] },
      { group: 'は', kanas: ['ハ', 'ヒ', 'フ', 'ヘ', 'ホ', 'バ', 'ビ', 'ブ', 'ベ', 'ボ', 'パ', 'ピ', 'プ', 'ペ', 'ポ'] },
      { group: 'ま', kanas: ['マ', 'ミ', 'ム', 'メ', 'モ'] },
      { group: 'や', kanas: ['ヤ', 'ユ', 'ヨ'] },
      { group: 'ら', kanas: ['ラ', 'リ', 'ル', 'レ', 'ロ'] },
      { group: 'わ', kanas: ['ワ', 'ヲ', 'ン'] }
    ];

    const kanaGroupData = [];

    kanaGroups.forEach(({ group, kanas }) => {
      const groupCities = this.controller.cities.filter(city => {
        if (!city.yomi) return false;
        const firstChar = city.yomi.slice(0, 1);
        return kanas.includes(firstChar);
      });

      if (groupCities.length > 0) {
        kanaGroupData.push({ kana: group, cities: groupCities });
      }
    });

    kanaGroupData.forEach((group) => {
      if (group.cities.length > 0) {
        const groupTitle = document.createElement('div');
        groupTitle.className = 'area-search__dropdown-city-group-title';
        groupTitle.textContent = `${group.kana}行`;
        container.appendChild(groupTitle);

        const groupButtons = document.createElement('div');
        groupButtons.className = 'area-search__dropdown-city-group-buttons';

        group.cities.forEach(city => {
          const button = document.createElement('button');
          button.className = 'area-search__dropdown-button';
          button.type = 'button';
          button.textContent = city.name;
          button.dataset.cityId = city.id;
          button.dataset.cityName = city.name;

          if (city.enabled) {
            button.dataset.action = 'click->refosumu--home-index--subsidy-section--area-search#selectCity';
          } else {
            button.classList.add('disabled');
            button.disabled = true;
          }

          groupButtons.appendChild(button);
        });

        container.appendChild(groupButtons);
      }
    });
  }

  // ========================================
  // 市区町村選択
  // ========================================

  selectCity(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const cityId = button.dataset.cityId;
    const cityName = button.dataset.cityName;

    // 前回選択された市区町村ボタンのselectedクラスを削除
    const allButtons = this.controller.cityDropdownTarget.querySelectorAll('.area-search__dropdown-button');
    allButtons.forEach(btn => btn.classList.remove('selected'));

    // 新しく選択されたボタンにselectedクラスを追加
    button.classList.add('selected');

    // 選択状態を更新
    this.controller.selectedCity = cityId;
    this.controller.selectedCityName = cityName;

    // テキストを更新
    this.controller.cityTextTarget.textContent = cityName;
    this.controller.cityInputTarget.classList.add('area-search__select--selected');

    // ドロップダウンを閉じる
    this.closeCityDropdown();
  }
}
